import React, { useState, useRef, useEffect } from 'react';
import api from '../services/api';
import './ChatBotGemini.css';

const ChatBotGemini = ({ onClose }) => {
  const [messages, setMessages] = useState([
    { role: 'agent', text: "Bonjour ! Je suis votre assistant IA Bfret. Comment puis-je vous aider aujourd'hui ?" }
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const chatEndRef = useRef(null);
  const [fullScreen, setFullScreen] = useState(false);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, loading]);

  const sendMessage = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    const userMsg = input;
    setMessages((prev) => [...prev, { role: 'user', text: userMsg }]);
    setInput("");
    setLoading(true);

    try {
      const res = await api.post('/agent/planning/ask', {
        query: userMsg,
        missionId: null
      });
      const botText = res.data?.answer || res.data?.text || "Désolé, je n'ai pas pu comprendre cela.";
      setMessages((prev) => [...prev, { role: 'agent', text: botText }]);
    } catch {
      setMessages((prev) => [...prev, { role: 'agent', text: "L'agent IA est indisponible. Veuillez vérifier sa configuration." }]);
    } finally {
      setLoading(false);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={`chatbot-gemini-overlay${fullScreen ? ' fullscreen' : ''}`} onClick={handleOverlayClick}>
      <div className={`chatbot-gemini-container${fullScreen ? ' fullscreen' : ''}`}>
        {/* Header */}
        <div className="chatbot-gemini-header">
          <div className="chatbot-gemini-header-title">
            <i className="bi bi-robot" style={{ color: '#4285F4', fontSize: 22 }}></i>
            <h2 style={{ margin: 0, fontSize: 18, fontWeight: 600, color: '#1a237e' }}>Chatbot</h2>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <button
              className="chatbot-gemini-fullscreen-btn"
              title={fullScreen ? "Réduire" : "Plein écran"}
              onClick={() => setFullScreen(fs => !fs)}
            >
              <i className={`bi ${fullScreen ? "bi-fullscreen-exit" : "bi-fullscreen"}`}></i>
            </button>
            <button onClick={onClose} title="Close" className="chatbot-gemini-close-btn">
              <i className="bi bi-x-lg"></i>
            </button>
          </div>
        </div>

        {/* Messages */}
        <div className="chatbot-gemini-messages">
          {messages.map((msg, idx) => (
            <div key={idx} className={`chatbot-gemini-message-row${msg.role === 'user' ? ' user' : ''}`}>
              {msg.role === 'agent' && (
                <div className="chatbot-gemini-avatar">
                  <i className="bi bi-robot"></i>
                </div>
              )}
              <div className={`chatbot-gemini-message${msg.role === 'user' ? ' user' : ''}`}>
                {msg.text}
              </div>
            </div>
          ))}
          {loading && (
            <div className="chatbot-gemini-loading">
              <div className="chatbot-gemini-loading-avatar">
                <i className="bi bi-robot"></i>
              </div>
              <div className="chatbot-gemini-loading-message">
                ...
              </div>
            </div>
          )}
          <div ref={chatEndRef} />
        </div>

        {/* Input Area */}
        <form onSubmit={sendMessage} className="chatbot-gemini-input-row">
          <input
            type="text"
            value={input}
            onChange={e => setInput(e.target.value)}
            placeholder="Type your message..."
            className="chatbot-gemini-input"
            disabled={loading}
          />
          <button type="submit" disabled={loading || !input.trim()} className="chatbot-gemini-send-btn">
            <i className="bi bi-send-fill"></i>
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChatBotGemini;